package com.patronat.top.client.location

import kotlinx.browser.window
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlin.coroutines.resume
import kotlin.js.json
import kotlin.js.jsTypeOf

class JsClientLocationProvider : ClientLocationProvider {
    override suspend fun getCurrentLocation(): ClientGeoLocation? {
        return suspendCancellableCoroutine { continuation ->
            val geolocation = window.navigator.asDynamic().geolocation
            if (jsTypeOf(geolocation) == "undefined" || geolocation == null) {
                continuation.resume(null)
                return@suspendCancellableCoroutine
            }

            geolocation.getCurrentPosition(
                { position: dynamic ->
                    if (continuation.isActive) {
                        continuation.resume(
                            ClientGeoLocation(
                                latitude = position.coords.latitude as Double,
                                longitude = position.coords.longitude as Double
                            )
                        )
                    }
                },
                { _: dynamic ->
                    if (continuation.isActive) {
                        continuation.resume(null)
                    }
                },
                json(
                    "enableHighAccuracy" to false,
                    "timeout" to 7000,
                    "maximumAge" to 300000
                )
            )
        }
    }
}
